// extracted by mini-css-extract-plugin
module.exports = {"PublishingDate":"PublishingDate_PublishingDate__R7vuf"};